import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import "./registerServiceWorker";

import BootstrapVue from "bootstrap-vue";
import Vuelidate from "vuelidate";
import {
  filters
} from "./filters/common";

import i18n from "@/plugins/i18n";
import FlagIcon from "vue-flag-icon";
// import VueLodash from "vue-lodash";
// const options = { name: 'lodash' } // customize the way you want to call it
import "./assets/vendor/jquery/jquery.min.js";
import "./assets/vendor/bootstrap/js/bootstrap.bundle.min.js";
import "./assets/vendor/jquery-easing/jquery.easing.min.js";
import "./assets/js/sb-admin-2.min.js";
import Modal from "bootstrap-vue/es/components/modal";
import CxltToastr from "cxlt-vue2-toastr";
import "cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css";
import {
  authenticationService
} from "./store/auth.module";

import {
  VueSpinners
} from "@saeris/vue-spinners";
import VueCookies from "vue-cookies";
import VueSession from "vue-session";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import VueLazyload from "vue-lazyload";
import "@/assets/global.css";
import "vue2-datepicker/locale/zh-cn";
import {
  SEND_NOTIFICATION_COUNT
} from "@/store/actions.type";
import {
  messaging
} from "./connectFCM.js"



// Init plugin
Vue.use(Loading);
Vue.use(require("vue-moment"));

Vue.use(VueCookies);
Vue.use(VueLazyload);
Vue.use(VueSession);
Vue.use(BootstrapVue);
Vue.use(Modal);
Vue.use(CxltToastr, {
  position: "top center",
  timeOut: 5000
});
Vue.use(VueSpinners);

// import './assets/vendor/jquery-easing/jquery.easing.min.js'
// import './assets/js/sb-admin-2.min.js'

// Vue.use(VueLodash); // options is optional

Vue.use(Vuelidate);

Vue.use(FlagIcon);

/*register global filters*/
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));

Vue.config.productionTip = false;
const ignoreWarnMessage =
  "The .native modifier for v-on is only valid on components but it was used on <div>.";
Vue.config.warnHandler = function (msg, vm, trace) {
  // `trace` is the component hierarchy trace
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
};

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const {
    authorize
  } = to.meta;
  const currentUser = authenticationService.currentUserValue;

  if (authorize) {
    if (!currentUser) {
      // not logged in so redirect to login page with the return url
      return next({
        path: "/login",
        query: {
          returnUrl: to.path
        }
      });
    }

    // check if route is restricted by role
    if (authorize.length && !authorize.includes(currentUser.role)) {
      // role not authorised so redirect to home page
      return next({
        path: "/"
      });
    }
  }

  next();
});
if (messaging) {
  messaging.onMessage(function (payload) {
    console.log("Recived Message", payload)
    navigator.serviceWorker.getRegistration('/firebase-cloud-messaging-push-scope').then(registration => {
      registration.showNotification(
        payload.notification.title,
        payload.notification
      )

    });
    store.dispatch(SEND_NOTIFICATION_COUNT, payload).then(data => {
      console.log("data", data)
    })

  })
}

new Vue({
  i18n,
  router,
  store,

  render: h => h(App)
}).$mount("#app");